<template>
  <div>
    <div class="MuiContainer-root MuiContainer-maxWidthLg" style="margin-top: 120px;">
       <div style="margin-bottom: 60px;">
        <div class="sc-iCfMLu eDTiIH">
            <h1>Privacy Statement</h1>
            <hr class="MuiDivider-root my-10">
            <p>
              artWormz DAO is committed to protecting the privacy and accuracy of confidential information to the extent possible, subject to provisions of state and federal law per country and worldwide. If you make use of our services, you state that you have read, understood, and agreed with our privacy policy.
            </p>
            <h2 class="my-8">
              We care about your privacy
            </h2>
            <h2 class="my-8">
             Cookies
            </h2>
            <p>
              If you leave a comment on our site you may opt-in to save your name, email address, and website in cookies. These are for your convenience so that you do not have to fill in your details again when you leave another comment. These cookies will last for one year.
            </p>
            <p>
              If you have an account and you log in to this site, we will set a temporary cookie to determine if your browser accepts cookies. This cookie contains no personal data and is discarded when you close your browser.
            </p>
            <p>
              When you log in, we will also set up several cookies to save your login information and your screen display choices. Login cookies last for two days, and screen options cookies last for a year. If you select “Remember Me”, your login will persist for two weeks. If you log out of your account, the login cookies will be removed.
            </p>
            <p>
              If you edit or publish an article, an additional cookie will be saved in your browser. This cookie includes no personal data and simply indicates the post ID of the article you just edited. It expires after 1 day.
            </p>
            <p>
              artWormz DAO makes use of Google Analytics which is a third-party cookie that tracks certain information to improve our services.
            </p>
            <h2 class="my-8">
             Comments
            </h2>
            <p>
              When visitors leave comments on the site, we collect the data shown in the comments form, and also the visitor’s IP address and browser user agent string to help spam detection.
            </p>
            <p>
              An anonymized string created from your email address (also called a hash) may be provided to the Gravatar service to see if you are using it. The Gravatar service privacy policy is available here: https://automattic.com/privacy/. After approval of your comment, your profile picture is visible to the public in the context of your comment.
            </p>
            <h2 class="my-8">
             Media
            </h2>
            <p>
              If you upload images to the website, you should avoid uploading images with embedded location data (EXIF GPS) included. Visitors to the website can download and extract any location data from images on the website.
            </p>
            <h2 class="my-8">
             Media
            </h2>
            <p>
              If you upload images to the website, you should avoid uploading images with embedded location data (EXIF GPS) included. Visitors to the website can download and extract any location data from images on the website.
            </p>
            <h2 class="my-8">
             The use of data
            </h2>
            <p>
              We do not sell, lease, rent, or otherwise disclose your personal data to any third party. Visitor comments may be checked through an automated spam detection service.
            </p>
            <p>
              We do use your data for the following reasons:
              <ul>
                <li>To comply with the law and governmental requests</li>
                <li>To prevent fraud</li>
                <li>To optimize your experience on our website</li>
              </ul>
            </p>
            <p>The information can be collected automatically through cookies or filled in by yourself when creating an account. There is the information we do not collect such as private keys or wallet seed. Do not trust anyone or any message you receive that are asking for this kind of private information. If something like this occurs on our website please notify us immediately.</p>
            <p>
              If you leave a comment, the comment and its metadata are retained indefinitely. This is so we can recognize and approve any follow-up comments automatically instead of holding them in a moderation queue.
            </p>
            <p>
              For users that register on our website (if any), we also store the personal information they provide in their user profile. All users can see, edit, or delete their personal information at any time (except they cannot change their username). Website administrators can also see and edit that information.
            </p>
            <p>
              If you have an account on this site or have left comments, you can request to receive an exported file of the personal data we hold about you, including any data you have provided to us. You can also request that we erase any personal data we hold about you. This does not include any data we are obliged to keep for administrative, legal, or security purposes.
            </p>
            <h2 class="my-8">
             What happens if the privacy statement change
            </h2>
            <p>
              This Privacy Statement was last revised on 01-10-2020. We may change this Privacy Statement at any time and for any reason. We encourage you to review this Privacy Statement each time you visit the website.
            </p>
            <p>
              If we decide to make a significant change to our Privacy Statement, we will post a notice on the homepage of our website for a period of time after the change is made.
            </p>
            <h2 class="my-8">
             Privacy of third parties
            </h2>
            <p>
              artWormz DAO may contain links to other websites. Some of those websites may be operated by third parties. We provide the links for your convenience, but we do not review, control, or monitor the privacy practices of websites operated by others. We are not responsible for the performance of websites operated by third parties or for your business dealings with them. Therefore, whenever you leave this website, we recommend that you review each websites’ privacy practices and make your own conclusions regarding the adequacy of these practices.
            </p>
            <p>
              Articles on this site may include embedded content (e.g. videos, images, articles, etc.). Embedded content from other websites behaves in the exact same way as if the visitor has visited the other website. These websites may collect data about you, use cookies, embed additional third-party tracking, and monitor your interaction with that embedded content, including tracking your interaction with the embedded content if you have an account and are logged in to that website.
            </p>
            <h2 class="my-8">
             Contact
            </h2>
            <p>
              If you have questions or comments about this Privacy Statement, please reach us on our Telegram and Discord channels.
            </p>
        </div>
       </div>
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return {

        }
    },
    created(){

    },
    mounted(){

    },
    computed: {

    },
    watch:{

    },
    methods: {

    },
}
</script>
<style lang="scss" scoped>
  .MuiDivider-root {
    border: none;
    height: 1px;
    margin: 0;
    flex-shrink: 0;
    background-color: #ddd;
  }
</style>



// WEBPACK FOOTER //
// src/views/common/PrivacyStatement.vue